var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-content-center m-0 mt-5"},[_c('div',{staticClass:"col-xl-6 text-center mt-5 mb-5"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.titulo)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }